import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import MedicineService from '../../../services/medicineService';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import Translate from '../../../common/functions/translate';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { SyncSettingsModel } from "../../../models/dataSynchronization";
import { Dropdown } from 'primereact/dropdown';
// import { NotificationScheduleType, NotificationAlarmType, NotificationFrequency } from "../../../common/enums";
import { DropdownModel } from "../../../models/dropdownModel";
import { enumToDropdownArray, fomatDateAsString, formatAlarmTime, fomatDateTimeAsString } from '../../../common/functions/helperFunctions';
import { Calendar } from 'primereact/calendar';
import { Spinner } from 'primereact/spinner';
import { Checkbox } from 'primereact/checkbox';
import { DataSourceType } from '../../../common/enums';
import { InputTextarea } from 'primereact/inputtextarea';
import { FullSyncResultModel } from "../../../models/dataSynchronization";
import { Accordion, AccordionTab } from 'primereact/accordion';

interface IProps {
  schedulerReport: FullSyncResultModel,
  isVisible: boolean,
  cancelClick: any
}

interface IState {
  isLoading: boolean;
  error: any;
  validationMessage: string;
  schedulerReport: FullSyncResultModel,
  activeIndex?: number
}


class SyncSchedulerReportDialog extends React.Component<IProps, IState> {
  medicineService = new MedicineService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      error: null,
      validationMessage: '',
      schedulerReport: this.props.schedulerReport,
      activeIndex: undefined
    }
  }

  componentDidMount() {
  }

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  render() {

    let { error, schedulerReport } = this.state;

    let allToSync: number = 0;
    let newInserted: number = 0;
    let updated: number = 0;
    let allFailed: number = 0;
    if (schedulerReport && schedulerReport.syncResult && schedulerReport.updateResult) {
      allToSync = schedulerReport.syncResult.medicinesToSyncCount + schedulerReport.updateResult.allMedicinesToUpdateCount;
      newInserted = schedulerReport.syncResult.syncedMedcinesCount;
      updated = schedulerReport.updateResult.medicinesAuthorisedCount + schedulerReport.updateResult.medicinesSuspendedCount;
      allFailed = schedulerReport.syncResult.syncFailedCount + schedulerReport.updateResult.medicinesAuthorisedTransactionFailedCount + schedulerReport.updateResult.medicinesSuspendedTransactionFailedCount;
    }

    return (
      <Dialog
        header={Translate('Scheduler Report')}
        responsive={true}
        width="60%"
        modal={true}
        visible={this.props.isVisible}
        onHide={this.handleCancelButton}
        footer={
          <div>
            <Button label={Translate('Cancel')} icon="pi pi-times" onClick={this.handleCancelButton} className="p-button-secondary p-button-raised" />
          </div>
        }>
        <div style={{ minHeight: '450px', maxHeight: '700px' }}>
          {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
          {error && error.message ? <AlertMessage type='danger'>{error.message}</AlertMessage> : null}

          <div className="p-grid p-fluid dashboard">
            <div className="p-col-12 p-lg-3">
              <div className="card summary">
                <span className="title">Synchronization</span>
                <span className="detail">Medicines to synchronize</span>
                <span className="count addtional">{allToSync}</span>
              </div>
            </div>
            <div className="p-col-12 p-lg-3">
              <div className="card summary">
                <span className="title">New</span>
                <span className="detail">Medicines inserted</span>
                <span className="count medicines">{newInserted}</span>
              </div>
            </div>
            <div className="p-col-12 p-lg-3">
              <div className="card summary">
                <span className="title">Update</span>
                <span className="detail">Medicines updated</span>
                <span className="count users">{updated}</span>
              </div>
            </div>
            <div className="p-col-12 p-lg-3">
              <div className="card summary">
                <span className="title">Failed</span>
                <span className="detail">Transactions failed</span>
                <span className="count active-ingredients">{allFailed}</span>
              </div>
            </div>
          </div>

          <Accordion
            activeIndex={this.state.activeIndex}
            onTabChange={(e) => this.setState({ activeIndex: e.index })}
          >
            <AccordionTab header={Translate('Synchronization result')}>
              <div className="p-grid p-fluid dashboard">
                <div className="p-col-12 p-lg-4">
                  <div className="card summary">
                    <span className="title">Synchronization</span>
                    <span className="detail">Medicines to insert</span>
                    <span className="count addtional">{schedulerReport && schedulerReport.syncResult ? schedulerReport.syncResult.medicinesToSyncCount : 0}</span>
                  </div>
                </div>
                <div className="p-col-12 p-lg-4">
                  <div className="card summary">
                    <span className="title">Medicines</span>
                    <span className="detail">Medicines inserted</span>
                    <span className="count medicines">{schedulerReport && schedulerReport.syncResult ? schedulerReport.syncResult.syncedMedcinesCount : 0}</span>
                  </div>
                </div>
                <div className="p-col-12 p-lg-4">
                  <div className="card summary">
                    <span className="title">Failed</span>
                    <span className="detail">Transactions failed</span>
                    <span className="count active-ingredients">{schedulerReport && schedulerReport.syncResult ? schedulerReport.syncResult.syncFailedCount : 0}</span>
                  </div>
                </div>
                <div className="p-col-12 p-lg-4">
                  <div className="card summary">
                    <span className="title">Files</span>
                    <span className="detail">Files inserted</span>
                    <span className="count manufacturers">{schedulerReport && schedulerReport.syncResult ? schedulerReport.syncResult.newFilesCount : 0}</span>
                  </div>
                </div>
                <div className="p-col-12 p-lg-4">
                  <div className="card summary">
                    <span className="title">Manufacturers</span>
                    <span className="detail">Manufacturers inserted</span>
                    <span className="count manufacturers"> {schedulerReport && schedulerReport.syncResult ? schedulerReport.syncResult.newManufaturersCount : 0}</span>
                  </div>
                </div>
                <div className="p-col-12 p-lg-4">
                  <div className="card summary">
                    <span className="title">Authorization holders</span>
                    <span className="detail">Aauthorization holders inserted</span>
                    <span className="count manufacturers"> {schedulerReport && schedulerReport.syncResult ? schedulerReport.syncResult.newAuthorisationHoldersCount : 0}</span>
                  </div>
                </div>
                <div className="p-col-12 p-lg-4">
                  <div className="card summary">
                    <span className="title">Active ingredients</span>
                    <span className="detail">Active ingredients inserted</span>
                    <span className="count manufacturers"> {schedulerReport && schedulerReport.syncResult ? schedulerReport.syncResult.newActiveIngredientsCount : 0}</span>
                  </div>
                </div>
                <div className="p-col-12 p-lg-4">
                  <div className="card summary">
                    <span className="title">Inactive ingredients</span>
                    <span className="detail">Inactive ingredients inserted</span>
                    <span className="count manufacturers"> {schedulerReport && schedulerReport.syncResult ? schedulerReport.syncResult.newInactiveIngredientsCount : 0}</span>
                  </div>
                </div>
              </div>
            </AccordionTab>
            <AccordionTab header={Translate('Update result')}>
              <div className="p-grid p-fluid dashboard">
                <div className="p-col-12 p-lg-4">
                  <div className="card summary">
                    <span className="title">Update</span>
                    <span className="detail">Medicines to update</span>
                    <span className="count addtional">{schedulerReport && schedulerReport.updateResult ? schedulerReport.updateResult.allMedicinesToUpdateCount : 0}</span>
                  </div>
                </div>
                <div className="p-col-12 p-lg-4">
                  <div className="card summary">
                    <span className="title">Medicines</span>
                    <span className="detail">Medicines updated</span>
                    <span className="count medicines">{schedulerReport && schedulerReport.updateResult ? schedulerReport.updateResult.medicinesAuthorisedCount + schedulerReport.updateResult.medicinesSuspendedCount : 0}</span>
                  </div>
                </div>
                <div className="p-col-12 p-lg-4">
                  <div className="card summary">
                    <span className="title">Failed</span>
                    <span className="detail">Update transactions failed</span>
                    <span className="count active-ingredients">{schedulerReport && schedulerReport.updateResult ? schedulerReport.updateResult.medicinesAuthorisedTransactionFailedCount + schedulerReport.updateResult.medicinesSuspendedTransactionFailedCount : 0}</span>
                  </div>
                </div>
              </div>
            </AccordionTab>
            <AccordionTab header={Translate('Import result')}>
              <div className="p-grid p-fluid dashboard">
                <div className="p-col-12 p-lg-4">
                  <div className="card summary">
                    <span className="title">Import</span>
                    <span className="detail">Medicines to import</span>
                    <span className="count addtional">{schedulerReport && schedulerReport.importResult ? schedulerReport.importResult.medicinesToImportCount : 0}</span>
                  </div>
                </div>
                <div className="p-col-12 p-lg-4">
                  <div className="card summary">
                    <span className="title">Imported</span>
                    <span className="detail">Medicines imported</span>
                    <span className="count medicines">{schedulerReport && schedulerReport.importResult ? schedulerReport.importResult.importedMedcinesCount : 0}</span>
                  </div>
                </div>
                <div className="p-col-12 p-lg-4">
                  <div className="card summary">
                    <span className="title">Failed</span>
                    <span className="detail">Import transactions failed</span>
                    <span className="count active-ingredients">{schedulerReport && schedulerReport.importResult ? schedulerReport.importResult.importFailedCount : 0}</span>
                  </div>
                </div>
              </div>
            </AccordionTab>
            <AccordionTab header={Translate('Load result')}>
              LOAD CONTENT HERE
            </AccordionTab>
          </Accordion>
        </div>
      </Dialog >
    )
  }
}

export default SyncSchedulerReportDialog;